<!-- dashboard.component.html -->
<section class="content dashboard-page">
  <app-content-header [title]="'Dashboard'"></app-content-header>
  <section class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-4">
          <app-small-box [title]="'Blogs'" [text]="blogCount" [navigateTo]="'/dashboard/blog'" [variant]="'info'" [icon]="{content: faPaper}"></app-small-box>
        </div>
        <div class="col-md-4" *ngIf="homeCount">
          <app-small-box [title]="'Homes'" [text]="'53 %'" [navigateTo]="'/dashboard/home'" [variant]="'success'" [icon]="{content: faHome}"></app-small-box>
        </div>
        <div class="col-md-4">
          <app-small-box [title]="'Projects'" [text]="projectCount" [navigateTo]="'/dashboard/portfoilo'" [variant]="'success'" [icon]="{content: faCubes}"></app-small-box>
        </div>
      </div>
    </div>
  </section>
</section>
